module.exports = __webpack_public_path__ + "img/apartment.10027d5b.svg";